import React from "react";
import { connect } from "react-redux";
import { setRedux } from "./../../actions/index";
import { Table, Label, Input } from "semantic-ui-react";
import NumberFormat from "react-number-format";
import TextField from "@material-ui/core/TextField";
import _ from "lodash";


class RxinfoOD extends React.Component {
  state = {
    err_od_sph: false,
    err_od_cyl: false,
    err_od_axis: false,
    err_od_add: false,
    err_od_pd: false,
    err_od_seg: false,
    err_od_oc: false,
    err_od_npd: false,
    validate: this.props.validate,
    add_disabled: false,
    oc_disabled: false,
    seg_disabled: false,
    //axis_disabled: true,
    lensType: "",
    resetCode: this.props.resetCode
  };


  componentDidUpdate() {
    //error check
    if (this.state.validate !== this.props.validate) {
      //reset error field
      this.setState({
        err_od_sph: false,
        err_od_cyl: false,
        err_od_axis: false,
        err_od_add: false,
        err_od_pd: false,
        err_od_seg: false,
        err_od_npd: false,
        err_od_oc: false
      });
      //set error field according to submit button
      this.props.validate.map(item => {
        this.setState({ ["err_" + item]: true });
        return null;
      });
      this.setState({ validate: this.props.validate });
    }

    //lens type check
    if (this.props.lensType !== this.state.lensType) {
      this.setState({
        add_disabled: false,
        oc_disabled: false,
        seg_disabled: false
      });
      if (this.props.lensType === "sv") {
        this.setState({ add_disabled: true, seg_disabled: true });
        this.props.setRedux("od_add", "");
        this.props.setRedux("od_seg", "");
      } else {
        this.setState({ oc_disabled: true });
        this.props.setRedux("od_oc", "");
      }

      this.setState({ lensType: this.props.lensType });
    }

    //reset
    this.state.resetCode !== this.props.resetCode &&
      this.setState({ resetCode: this.props.resetCode, axis_disabled: true });
  }

  copyOdToOs = vFr => {
    const vTo = vFr === "od" ? "os" : "od";
    const copyItems = [
      "_sph",
      "_cyl",
      "_axis",
      "_add",
      "_seg",
      "_oc",
      "_base",
      "_pd",
      "_npd",
      "_thk"
    ];
    copyItems.map(item =>
      this.props.setRedux(vTo + item, this.props[vFr + item])
    );
  };

  showError = (val, rangemax, rangemin) => {
    let text = "";
    let returnValue = "";
    if (val > rangemax) text = "too hight";
    else if (val < rangemin) text = "too low";
    else text = "";

    if (text !== "") {
      returnValue = (
        <Label color="red" pointing>
          {text}
        </Label>
      );
    }

    return returnValue;
  };

  cInput = () => {
    return <Input error></Input>;
  };

  render() {
    const { setAxisDisabled, axisDisabled } = this.props;
    return (
      <Table.Row>
        <Table.Cell>
          <div className="center aligned">OD</div>
        </Table.Cell>
        <Table.Cell>
          <div className="ui input">
            <NumberFormat
              name="od_sph"
              autoComplete="off"
              value={this.props.od_sph}
              onChange={async e => {
                await this.props.setRedux(e.target.name, e.target.value);
                (await this.props.od_sph) !== "" &&
                  this.setState({ err_od_sph: false });
              }}
              prefix={this.props.od_sph >= 0 ? "+" : ""}              
              maxLength="6"
              className="ui input"
              decimalScale={2}
              fixedDecimalScale={true}
              //customize field
              customInput={TextField}
              error={this.state.err_od_sph}
              variant="outlined"
            />
          </div>
          {this.showError(
            this.props.od_sph,
            this.props.powermax,
            this.props.powermin
          )}
        </Table.Cell>

        <Table.Cell>
          <div className="ui input">
            <NumberFormat
              name="od_cyl"
              autoComplete="off"
              value={this.props.od_cyl}
              onChange={async e => {
                let value = e.target.value.replace("+","");
                value = value.search("-") ? "+" + value : value ;
                await this.props.setRedux(e.target.name, value);
                (await this.props.od_cyl) !== "" &&
                  this.setState({ err_od_cyl: false });
                //set axis
                if (this.props.od_cyl !== "+0.00" && this.props.od_cyl !== "") {
                  //this.setState({ axis_disabled: false });
                  setAxisDisabled("od", false);
                } else {
                  //this.setState({ axis_disabled: true });
                  setAxisDisabled("od", true);
                  this.props.setRedux("od_axis", "");
                }
              }}

              maxLength="6"
              className="ui small input"
              prefix={this.props.od_cyl >= 0 ? "+" : ""}
              decimalScale={2}
              fixedDecimalScale={true}
              //customize field
              customInput={TextField}
              error={this.state.err_od_cyl}
              variant="outlined"
            />
          </div>
          {this.showError(
            this.props.od_cyl,
            this.props.cylmax,
            this.props.cylmax * -1
          )}
        </Table.Cell>

        <Table.Cell>
          <div className="ui input">
            <NumberFormat
              name="od_axis"
              autoComplete="off"
              value={this.props.od_axis}
              onChange={async e => {
                await this.props.setRedux(e.target.name, e.target.value);
                (await this.props.od_axis) !== "" &&
                  this.setState({ err_od_axis: false });
              }}              
              maxLength="6"
              className="ui small input"
              allowNegative={false}
              //customize field
              customInput={TextField}
              error={this.state.err_od_axis}
              variant={axisDisabled ? "filled" : "outlined"}
              disabled={axisDisabled}
            //disabled={this.state.axis_disabled}
            />
          </div>
          {this.showError(this.props.od_axis, 180, 0)}
        </Table.Cell>

        <Table.Cell>
          <div className="ui input">
            <NumberFormat
              name="od_add"
              autoComplete="off"
              value={this.props.od_add}
              onChange={async e => {
                await this.props.setRedux(e.target.name, e.target.value);
                (await this.props.od_add) !== "" &&
                  this.setState({ err_od_add: false });
              }}              
              maxLength="6"
              className="ui small input"
              allowNegative={false}
              decimalScale={2}
              fixedDecimalScale={true}
              //customize field
              customInput={TextField}
              error={this.state.err_od_add}
              variant={this.state.add_disabled ? "filled" : "outlined"}
              disabled={this.state.add_disabled}
            />
          </div>
          {this.showError(this.props.od_add, this.props.addmax, 0)}
        </Table.Cell>

        <Table.Cell>
          <div className="ui input">
            <NumberFormat
              name="od_seg"
              autoComplete="off"
              value={this.props.od_seg}
              onChange={async e => {
                await this.props.setRedux(e.target.name, e.target.value);
                (await this.props.od_seg) !== "" &&
                  this.setState({ err_od_seg: false });
              }}              
              maxLength="6"
              className="ui small input"
              allowNegative={false}
              //customize field
              customInput={TextField}
              error={this.state.err_od_seg}
              variant={this.state.seg_disabled ? "filled" : "outlined"}
              disabled={this.state.seg_disabled}
            />
          </div>
        </Table.Cell>

        <Table.Cell>
          <div className="ui input">
            <NumberFormat
              name="od_oc"
              autoComplete="off"
              value={this.props.od_oc}
              onChange={async e => {
                await this.props.setRedux(e.target.name, e.target.value);
                (await this.props.od_oc) !== "" &&
                  this.setState({ err_od_oc: false });
              }}              
              maxLength="6"
              className="ui compact input"
              allowNegative={false}
              variant={this.state.oc_disabled ? "filled" : "outlined"}
              disabled={this.state.oc_disabled}
              customInput={TextField}
              error={this.state.err_od_oc}
            />
          </div>
        </Table.Cell>

        <Table.Cell>
          <div className="ui input">
            <NumberFormat
              name="od_base"
              autoComplete="off"
              value={this.props.od_base}
              onChange={e => this.props.setRedux(e.target.name, e.target.value)}              
              maxLength="6"
              className="ui small input"
              allowNegative={false}
              customInput={TextField}
              variant="outlined"
            />
          </div>
        </Table.Cell>

        <Table.Cell>
          <div className="ui input">
            <NumberFormat
              name="od_pd"
              autoComplete="off"
              value={this.props.od_pd}
              onChange={async e => {
                await this.props.setRedux(e.target.name, e.target.value);
                (await this.props.od_pd) !== "" &&
                  this.setState({ err_od_pd: false });
                (_.toNumber(this.props.od_npd) >= _.toNumber(this.props.od_pd))
                  ? this.setState({ err_od_npd: true })
                  : this.setState({ err_od_npd: false });
              }}              
              maxLength="6"
              className="ui small input"
              allowNegative={false}
              decimalScale={1}
              fixedDecimalScale={true}
              //customize field
              customInput={TextField}
              error={this.state.err_od_pd}
              variant="outlined"
            />
          </div>
        </Table.Cell>

        <Table.Cell>
          <div className="ui input">
            <NumberFormat
              name="od_npd"
              autoComplete="off"
              value={this.props.od_npd}
              onChange={async e => {
                await this.props.setRedux(e.target.name, e.target.value);
                (_.toNumber(this.props.od_npd) >= _.toNumber(this.props.od_pd))
                  ? this.setState({ err_od_npd: true })
                  : this.setState({ err_od_npd: false });
              }}              
              maxLength="6"
              className="ui small input"
              allowNegative={false}
              decimalScale={1}
              customInput={TextField}
              variant="outlined"
              error={this.state.err_od_npd}
              fixedDecimalScale={true}
            />
          </div>
          {this.showError(this.props.od_npd, this.props.od_pd, 0)}
        </Table.Cell>

        <Table.Cell>
          <div className="ui input">
            <NumberFormat
              name="od_thk"
              autoComplete="off"
              value={this.props.od_thk}
              onChange={e => this.props.setRedux(e.target.name, e.target.value)}              
              maxLength="6"
              className="ui small input"
              allowNegative={false}
              customInput={TextField}
              variant="outlined"
            />
          </div>
        </Table.Cell>
        <Table.Cell>
          <button
            className="ui icon basic button"
            onClick={() => {
              this.copyOdToOs("od");
              axisDisabled ? setAxisDisabled("os", true) : setAxisDisabled("os", false);
            }}
          >
            <i className="arrow down icon" size="large" />
            </button>
        </Table.Cell>
      </Table.Row>
    );
  }
}

const mapStateToProps = state => {
  return { ...state.job.jobInfo };
};

export default connect(mapStateToProps, { setRedux })(RxinfoOD);
